export default __webpack_public_path__ + "static/media/x3.4cb9dbfe.webp";